(() => {
  const body = document.body;

  if (!body || !body.classList.contains('template-product')) return;

  const state = {
    raf: null,
    observer: null,
  };

  const getStickyBar = () => document.querySelector('.product__popup.sticky-bar');

  const getOriginalPurchaseArea = () => {
    const areas = Array.from(
      document.querySelectorAll('[id^="MainProduct-"] .product__buy_buttons')
    ).filter((element) => !element.closest('.product__popup'));

    return areas.find((element) => element.offsetParent !== null) || areas[0] || null;
  };

  const setFormError = (form, message) => {
    const wrapper = form
      ?.closest('product-form')
      ?.querySelector('.product-form__error-message-wrapper');
    const target = wrapper?.querySelector('.product-form__error-message');

    if (!wrapper || !target) return;

    target.textContent = message || '';
    wrapper.toggleAttribute('hidden', !message);
  };

  const isUnavailable = (form) => {
    const idInput = form?.querySelector('[name="id"]');
    const addButton = form?.querySelector('.product-form__submit');

    return !idInput || !idInput.value || idInput.disabled || addButton?.disabled;
  };

  const ensureBuyNowButtons = (scope = document) => {
    scope
      .querySelectorAll('.product__buy_buttons .product-form__buttons')
      .forEach((container) => {
        if (container.querySelector('.shopping-buy-now')) return;

        const form = container.closest('form');
        if (!form) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button shopping-buy-now focus-inset';
        button.textContent = 'HEMEN SATIN AL';
        button.setAttribute('aria-label', 'Ürünü hemen satın al');

        if (isUnavailable(form)) {
          button.disabled = true;
          button.textContent = 'TÜKENDİ';
        }

        container.appendChild(button);
      });
  };

  const syncQuantities = (source) => {
    if (!source) return;

    const parsed = Number.parseInt(source.value, 10);
    const value = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;

    document
      .querySelectorAll('.product__buy_buttons input[name="quantity"]')
      .forEach((input) => {
        if (input !== source) input.value = value;
      });
  };

  const buyNow = async (button) => {
    const form = button.closest('form');
    if (!form || button.disabled) return;

    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value || idInput.disabled) {
      setFormError(form, 'Ürün şu anda satın alınamıyor.');
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'İŞLENİYOR…';
    setFormError(form, '');

    try {
      const formData = new FormData(form);
      formData.delete('sections');
      formData.delete('sections_url');

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.status) {
        throw new Error(
          result.description || result.message || 'Ürün sepete eklenemedi.'
        );
      }

      window.location.assign('/checkout');
    } catch (error) {
      setFormError(form, error.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    }
  };

  const updateStickyBar = () => {
    state.raf = null;

    const stickyBar = getStickyBar();
    const source = getOriginalPurchaseArea();

    if (!stickyBar || !source) {
      body.classList.remove('shopping-sticky-cart-active');
      return;
    }

    const header = document.querySelector('.shopify-section-header');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const sourceRect = source.getBoundingClientRect();
    const stickyHeight = stickyBar.getBoundingClientRect().height || 76;
    const footer = document.querySelector('footer');
    const footerIsClear =
      !footer || footer.getBoundingClientRect().top > window.innerHeight - stickyHeight;
    const overlayIsOpen =
      body.classList.contains('overflow-hidden') ||
      body.classList.contains('overflow-hidden-mobile') ||
      body.classList.contains('overflow-hidden-tablet');

    const shouldShow =
      sourceRect.bottom < headerHeight + 8 && footerIsClear && !overlayIsOpen;

    stickyBar.classList.toggle('shopping-sticky-visible', shouldShow);
    body.classList.toggle('shopping-sticky-cart-active', shouldShow);
  };

  const scheduleStickyUpdate = () => {
    if (state.raf) return;
    state.raf = window.requestAnimationFrame(updateStickyBar);
  };

  const init = () => {
    ensureBuyNowButtons();
    scheduleStickyUpdate();

    if (!state.observer) {
      state.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            ensureBuyNowButtons(node.matches('.product-form__buttons') ? node.parentElement : node);
          });
        });

        ensureBuyNowButtons();
        scheduleStickyUpdate();
      });

      state.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  document.addEventListener('click', (event) => {
    const buyButton = event.target.closest('.shopping-buy-now');
    if (buyButton) {
      event.preventDefault();
      buyNow(buyButton);
      return;
    }

    if (event.target.closest('.quantity__button')) {
      window.setTimeout(() => {
        const quantity = event.target
          .closest('.quantity')
          ?.querySelector('input[name="quantity"]');
        syncQuantities(quantity);
      }, 0);
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('.product__buy_buttons input[name="quantity"]')) {
      syncQuantities(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.product__buy_buttons input[name="quantity"]')) {
      syncQuantities(event.target);
    }
  });

  window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  window.addEventListener('resize', scheduleStickyUpdate, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', scheduleStickyUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
